import { render, staticRenderFns } from "./lrCarNumber.vue?vue&type=template&id=12b18594&"
import script from "./lrCarNumber.vue?vue&type=script&lang=js&"
export * from "./lrCarNumber.vue?vue&type=script&lang=js&"
import style0 from "./lrCarNumber.vue?vue&type=style&index=0&id=12b18594&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports